import { render, staticRenderFns } from "./argement.vue?vue&type=template&id=2f7fb2d6&scoped=true&"
import script from "./argement.vue?vue&type=script&lang=js&"
export * from "./argement.vue?vue&type=script&lang=js&"
import style0 from "./argement.vue?vue&type=style&index=0&id=2f7fb2d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7fb2d6",
  null
  
)

export default component.exports